import { h } from "vue";
import { RouteRecordRaw, RouterView } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    // Users
    {
        path: "/rights-management/users",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Users",
                meta: { title: "Benutzer" },
                component: () => import("@/views/rights-management/users/Users.vue"),
            },
            {
                path: "create",
                name: "UsersCreate",
                meta: { title: "Benutzer" },
                component: () => import("@/views/rights-management/users/components/User.vue"),
            },
            {
                path: ":id/edit",
                name: "UsersEdit",
                meta: { title: "Benutzer" },
                component: () => import("@/views/rights-management/users/components/User.vue"),
                props: true,
            },
        ],
    },

    // Roles
    {
        path: "/rights-management/roles",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Roles",
                meta: { title: "Rollen" },
                component: () => import("@/views/rights-management/roles/Roles.vue"),
            },
            {
                path: "create",
                name: "RolesCreate",
                meta: { title: "Rollen" },
                component: () => import("@/views/rights-management/roles/components/Role.vue"),
            },
            {
                path: ":id/edit",
                name: "RolesEdit",
                meta: { title: "Rollen" },
                component: () => import("@/views/rights-management/roles/components/Role.vue"),
                props: true,
            },
        ],
    },

    // Permissions
    {
        path: "/rights-management/permissions",
        name: "Permissions",
        meta: { title: "Berechtigungen" },
        component: () => import("@/views/rights-management/permissions/Permissions.vue"),
    },
];

export default routes;
